import {has} from 'ramda';
import {isPlainObj} from 'ramda-adjunct';

import {ApiException} from '../types/ApiException';

export function isApiException(errorData: unknown): errorData is ApiException {
  return !!(isPlainObj(errorData) && has('errors', errorData));
}
